/* eslint-disable @typescript-eslint/no-explicit-any */
import { first, switchMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';

import { CheckoutState, checkoutQuery, fromCheckoutActions } from '../+state';

@Injectable()
export class SpecialCreditBundleResolver {
  constructor(private _store: Store<CheckoutState>) {}

  /*
   * Resolve SpecialCreditBundle
   * 1. Selects SpecialCreditBundle from the store
   * 2. Checks SpecialCreditBundle.id is present
   *    -If it doesn't exist:
   *    1. GetSpecialCreditBundle with :id
   * 3. Checks paramQuoteUuid from url with present id
   *    - If it doesn't match:
   *    1. GetSpecialCreditBundle with :id
   *    - If it does match:
   *    1. Return getSpecialCreditBundle from Store
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this._store.pipe(select(checkoutQuery.getSpecialCreditBundle), first()).pipe(
      switchMap(() => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        const paramCreditBundleUuid = route.params.creditBundleUuid;
        this.getSpecialCreditBundle(paramCreditBundleUuid);
        return of(true);

        // if (!creditBundle) {
        //   return this.getSpecialCreditBundle(paramCreditBundleUuid);
        // }

        // if (paramCreditBundleUuid !== creditBundle.uuid) {
        //   return this.getSpecialCreditBundle(paramCreditBundleUuid);
        // }

        // return of(creditBundle);
      })
    );
  }

  /*
   * trigger fetching quote to send
   * 1. Dispatch getSpecialCreditBundle action
   * 2. Listening to setSpecialCreditBundle
   * 3. Return payload of setSpecialCreditBundle
   */
  private getSpecialCreditBundle(id: string) {
    this._store.dispatch(fromCheckoutActions.getSpecialCreditBundle({ payload: { id } }));
  }
}
